export class SaAdjustThreshold {

    constructor(json: any) {
        if (json) {
            Object.assign(this, json);
        }
    }

    isOverEnabled: boolean = false;
    isUnderEnabled: boolean = false;
    overThreshold: number = 200;
    underThreshold: number = 10;
    excludeZeros: boolean = false;
}
